export default __webpack_public_path__ + "static/media/img-3.282f0d0a.jpg";